export const translationLivechat_da_part2 = {
  livechatFailedTransferSession: "Kunne ikke overdrage livechat-sessionen.",
  livechatFailedCloseSession: "Kunne ikke lukke livechat-sessionen.",
  livechatFailedLoadSessions: "Kunne ikke indlæse livechat-sessioner.",
  livechatFailedLoadSession: "Kunne ikke indlæse livechat-sessionen.",
  livechatSessionUnavailableTitle: "Samtalen er ikke længere tilgængelig",
  livechatSessionUnavailableDescription:
    "Den kan være blevet slettet, fx fordi den besøgende har slettet sine data.",
  livechatFailedLoadTranscript: "Kunne ikke indlæse livechat-transkriptet.",
  livechatFailedLoadAiContext: "Kunne ikke indlæse AI-kontekst.",
  livechatFailedLoadAgents: "Kunne ikke indlæse livechat-agenter.",
  livechatFailedLoadSettings: "Kunne ikke indlæse livechat-indstillinger.",
  livechatFailedSaveSettings: "Kunne ikke gemme livechat-indstillinger.",
  livechatCloseReasonDashboard: "Lukket fra dashboard livechat-arbejdsområde",
  livechatConversationSelectTitle: "Vælg en livechat-session",
  livechatConversationSelectHint:
    "Vælg en ventende, aktiv eller lukket session for at se hele samtalen og konteksten.",
  livechatLiveSession: "Live session",
  livechatJoinSession: "Deltag i session",
  livechatJoining: "Deltager...",
  livechatTakeoverProviderControl: "Overtag",
  livechatTakingOverProviderControl: "Overtager...",
  livechatTransferSession: "Overdrag",
  livechatTransferredToYou: "Overdraget til dig",
  livechatTransferReceivedTitle: "Samtale overdraget til dig",
  livechatTransferReceivedOpen: "Åbn samtalen",
  livechatTransferReceivedOsBody: "En samtale er blevet overdraget til dig.",
  livechatTransferReceivedOsBodyFrom: "{agent} har overdraget en samtale til dig.",
  livechatSessionTakenOverTitle: "Samtale overtaget",
  livechatSessionTakenOverOsBody: "En anden agent har overtaget samtalen fra dig.",
  livechatSessionTakenOverOsBodyFrom: "{agent} har overtaget samtalen fra dig.",
  livechatTransferTargetLabel: "Overdrag til",
  livechatTransferNoTargets: "Ingen andre agenter er tilgængelige for denne chatbot.",
  livechatTransferConfirm: "Overdrag session",
  livechatTransferring: "Overdrager...",
  livechatTakeoverSession: "Overtag session",
  livechatTakingOverSession: "Overtager...",
  livechatCloseSession: "Luk session",
  livechatSessionClosed: "Session lukket",
  livechatClosing: "Lukker...",
  livechatSessionContext: "Sessionskontekst",
  livechatSessionMetadata: "Metadata · Ikke verificeret",
  livechatSessionMetadataHint:
    "Leveret af den besøgendes browser. Disse værdier er ikke verificeret.",
  livechatMetadataShowAll: "Vis alle ({count})",
  livechatMetadataHide: "Skjul",
  livechatSessionContextEnvironment: "Miljø",
  livechatSessionContextVisitorSession: "Besøgers session",
  livechatSessionContextLivechat: "Livechat",
  livechatSessionContextRequested: "Anmodet",
  livechatSessionContextAgentJoined: "Agent tilsluttet",
  livechatSessionContextClosed: "Lukket",
  livechatProvidedInformation: "Oplysninger fra kunden",
  livechatNotAvailable: "Ikke tilgængelig",
  livechatFeedback: "Feedback",
  livechatFeedbackSubmitted: "Sendt",
  livechatFeedbackSubmittedLine: "Sendt {datetime}",
  livechatNoFeedbackYet: "Ingen kundefeedback modtaget.",
  livechatWaitingForRating: "Venter på kundevurdering.",
  livechatCustomerTypingBadge: "Kunden skriver",
  livechatAiContextBeforeJoined: "AI-kontekst før agent deltog",
  livechatLoadingOlderContext: "Indlæser ældre kontekst...",
  livechatLoadingAiContext: "Indlæser AI-kontekst...",
  livechatBeforeLivechatRequest: "Før livechat-anmodning",
  livechatAiSessionEnded: "AI-session afsluttet",
  livechatWhileWaitingInQueue: "Mens der ventes i kø",
  livechatNoAiContext: "Ingen AI-kontekst tilgængelig.",
  livechatContextBeforeAgentJoined: "Kontekst før agent deltog",
  livechatLivechatTranscript: "Livechat-transkript",
  livechatSelectLanguageOption: "Vælg sprog",
  livechatTranslateTranscriptLanguage: "Vælg sprog til oversættelse af livechat-transkript",
  livechatTranslateTranscript: "Oversæt",
  livechatTranslatingTranscript: "Oversætter...",
  livechatFailedTranslateTranscript: "Kunne ikke oversætte livechat-transkriptet.",
  livechatTranslatedFrom: "Oversat fra {language}",
  livechatShowOriginal: "Vis original",
  livechatShowTranslation: "Vis oversættelse",
  livechatLanguageNameCs: "tjekkisk",
  livechatLanguageNameDa: "dansk",
  livechatLanguageNameDe: "tysk",
  livechatLanguageNameEn: "engelsk",
  livechatLanguageNameEs: "spansk",
  livechatLanguageNameFi: "finsk",
  livechatLanguageNameFr: "fransk",
  livechatLanguageNameIt: "italiensk",
  livechatLanguageNameNl: "hollandsk",
  livechatLanguageNameNo: "norsk",
  livechatLanguageNamePl: "polsk",
  livechatLanguageNameSv: "svensk",
  livechatLoadingContext: "Indlæser kontekst...",
  livechatNoContextAvailable: "Ingen kontekst tilgængelig.",
  livechatLoadingOlderMessages: "Indlæser ældre beskeder...",
  livechatLoadingTranscript: "Indlæser transkript...",
  livechatNoMessagesYet: "Der er endnu ikke udvekslet beskeder.",
  livechatCustomerIsTyping: "Kunden skriver...",
  livechatComposerReplyPlaceholder: "Svar til kunden...",
  livechatComposerJoinToReply: "Deltag i sessionen for at begynde at svare.",
  livechatComposerTakeoverToReply: "Overtag sessionen for at begynde at svare.",
  livechatComposerProviderOwned: "Udbyderen håndterer denne session.",
  livechatComposerOtherAgent: "En anden agent håndterer denne session.",
  livechatComposerSessionClosed: "Denne session er lukket.",
  livechatComposerSaveProfile: "Gem din profil for at kunne svare i livechat.",
  livechatAttachmentsSelected: "{count} vedhæftning valgt",
  livechatAttachmentsSelectedPlural: "{count} vedhæftninger valgt",
  livechatSendReply: "Send svar",
  livechatSending: "Sender...",
  livechatFailedSendMessage: "Kunne ikke sende beskeden.",
  livechatFailedReadFile: "Kunne ikke læse {filename}.",
  livechatAttachmentFallback: "Vedhæftning",
  livechatSaveProfileBeforeJoin:
    "Gem din livechat-profil før du deltager eller svarer i sessioner for denne chatbot.",
  livechatSetProfile: "Angiv profil",
  livechatAssignedToOtherAgent: "Denne session er i øjeblikket tildelt ",
  livechatProviderOwnedNotice: "Udbyderen håndterer denne session",
  livechatAnotherAgent: "en anden agent",
  livechatProfileModalTitle: "Livechat agentprofil",
  livechatProfileModalEyebrow: "{chatbotId} · {env} miljø",
  livechatProfileLoading: "Indlæser den aktive profil...",
  livechatProfileActivePrefix: "Aktiv profil:",
  livechatProfileNoneYet: "Der er endnu ikke gemt en livechat-profil for {chatbotId}.",
  livechatProfileNoChatbot: "Ingen chatbot",
  livechatDisplayName: "Visningsnavn",
  livechatAgentSpokenLanguages: "Sprog du skriver på",
  livechatAgentSpokenLanguagesHelp:
    "Kundens chat oversætter dine beskeder ud fra det valgte sprog. Lad stå tom for at tillade frit sprogvalg (meget korte beskeder kan gættes forkert). Ved flere sprog afgrænses automatisk til disse.",
  livechatAvatarUrl: "Avatar-URL",
  livechatAvatarPlaceholder: "https://cdn.example.com/avatar.png",
  livechatAvatarUploadImage: "Upload profilbillede",
};
